import React from 'react';

import staticURL from 'lib/staticURL';
import UpgradeAccountModal from 'start/upgrade-account/UpgradeAccountModal';

import NotificationBanner from './NotificationBanner';

interface UpgradeAccountBannerProps {
  onCloseBanner: () => void;
}

export default function UpgradeAccountBanner({onCloseBanner}: UpgradeAccountBannerProps): JSX.Element {
  return (
    <NotificationBanner
      onCloseBanner={onCloseBanner}
      imageURL={staticURL('/static/img/upgrade_account.png')}
      title="Want to get more out of Benchling?"
    >
      <div>
        <a
          onClick={() => {
            UpgradeAccountModal.open(undefined);
          }}
        >
          Upgrade your Benchling account
        </a>
      </div>
      to get enterprise-grade security, witness & review, workflow management, sample tracking, and more.
    </NotificationBanner>
  );
}
